import { gql } from "@apollo/client";
import { FRAGMENT_SECTIONS } from "../../graphql/section.fragment";
import { linkInfoFragment } from "./linkInfo.fragment";

export const linkSection = gql`
  query linkSection(
    $scenarioId: ID!
    $originId: ID!
    $resourceType: ResourceType!
    $resourceId: ID!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      editorView(resourceType: $resourceType, resourceId: $resourceId) {
        info {
          __typename
          ...LinkInfo
        }
        ...CalendarSections
      }
      editorWeeks(resourceType: $resourceType, resourceId: $resourceId) {
        id
        name
        startingDate
        endingDate
        eventCount
        termParts {
          id
          code
          name
          category {
            id
            code
            name
          }
        }
      }
    }
  }
  ${FRAGMENT_SECTIONS}
  ${linkInfoFragment}
`;
